
import React from 'react'
import {mdx} from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag mdx.Fragment */
import withLayout from 'nextra-theme-mui-docs';
import {withSSG} from 'nextra/ssg';
import layoutConfig from '/vercel/path0/docs/theme.config.js';
import PropertiesTable from '../../components/PropertiesTable';
import componentInfo from './Sparkline-componentInfo.json';
const MDXLayout = function NextraPage(props) {
  return withSSG(withLayout({
    filename: "Sparkline.mdx",
    route: "/component-api/Sparkline",
    meta: {},
    pageMap: [{
      "name": "component-api",
      "children": [{
        "name": "DataFilter",
        "route": "/component-api/DataFilter"
      }, {
        "name": "DataGrid",
        "route": "/component-api/DataGrid"
      }, {
        "name": "Sparkbars",
        "route": "/component-api/Sparkbars"
      }, {
        "name": "Sparkline",
        "route": "/component-api/Sparkline"
      }],
      "route": "/component-api"
    }, {
      "name": "components",
      "children": [{
        "name": "DataFilter",
        "route": "/components/DataFilter",
        "frontMatter": {
          "title": "DataFilter"
        }
      }, {
        "name": "DataGrid",
        "children": [{
          "name": "columns",
          "route": "/components/DataGrid/columns",
          "frontMatter": {
            "title": "Columns"
          }
        }, {
          "name": "index",
          "route": "/components/DataGrid",
          "frontMatter": {
            "title": "Basic Usage",
            "description": "Lorem ipsum dolor sit amet.",
            "order": ["index"]
          }
        }, {
          "name": "virtualization",
          "route": "/components/DataGrid/virtualization",
          "frontMatter": {
            "title": "Virtualization",
            "description": "Lorem ipsum dolor sit amet."
          }
        }],
        "route": "/components/DataGrid"
      }, {
        "name": "SelectionList",
        "route": "/components/SelectionList",
        "frontMatter": {
          "title": "Introduction",
          "hidden": true
        }
      }, {
        "name": "Sparkbars",
        "route": "/components/Sparkbars",
        "frontMatter": {
          "title": "Sparkbars"
        }
      }, {
        "name": "Sparkline",
        "route": "/components/Sparkline",
        "frontMatter": {
          "title": "Sparkline"
        }
      }, {
        "name": "visx",
        "route": "/components/visx"
      }],
      "route": "/components"
    }, {
      "name": "index",
      "route": "/",
      "frontMatter": {
        "title": "Introduction",
        "order": ["index", {
          "name": "components",
          "title": "Components"
        }, {
          "name": "component-api",
          "title": "Component Api"
        }, {
          "name": "more",
          "title": "More"
        }]
      }
    }, {
      "name": "more",
      "children": [{
        "name": "markdown",
        "route": "/more/markdown",
        "frontMatter": {
          "hidden": true
        }
      }, {
        "name": "nextra-theme-mui-docs",
        "route": "/more/nextra-theme-mui-docs"
      }],
      "route": "/more"
    }]
  }, layoutConfig))(props);
};
function MDXContent({components, ...props}) {
  return <MDXLayout components={components} {...props}><h1>{"Sparkline"}</h1><h2>{"import"}</h2><pre><code className="language-tsx" parentName="pre">{"import { Sparkline } from 'mui-plus';\n"}</code></pre><h2>{"Properties"}</h2>{"\n"}<PropertiesTable props={componentInfo.props} mdxType="PropertiesTable" /></MDXLayout>;
}
MDXContent.isMDXComponent = true;
export default MDXContent;
